import styled from 'styled-components'

import { convertHexToRGBA } from 'core/helpers'

const Label = styled.label`
  font-family: ${p => p.theme.fonts.secondary};
  font-weight: 600;
  padding: 0px 10px;
  color: ${p =>
    p.color && convertHexToRGBA({ hex: p.theme.colors.dark, opacity: 9 })};
`

export default Label
